var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.impressionId)?_c('span',{staticClass:"rt-gtm-impression",attrs:{"id":_vm.impressionId,"aria-hidden":"true"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }